module.exports = __webpack_public_path__ + "static/media/03-2-galeria-01-rimowa@2x.0f76075f.jpg";